<template>
  <div class="userinfo-service">
    <van-cell-group>
      <van-cell title="意见反馈"
                class="cell-custom"
                @click="goFeedback"
                is-link/>
      <van-cell title="常见问题"
                class="cell-custom"
                @click="goProblem"
                is-link/>
      <van-cell title="客服电话"
                class="cell-custom"
                @click="goPhone"
                is-link/>
    </van-cell-group>
  </div>
</template>
<script>
import { getOperInfo } from '../../common/api';
import {
  Cell,
  CellGroup,
} from "vant";
export default {
  name: 'userinfo-service',
  data(){
    return{
      operData: {}
    }
  },
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  methods: {
    goFeedback(){
      this.$router.push({ name: "feedback-list",query: {chargeUserPkId: this.$route.query.chargeUserPkId} });
    },
    goPhone(){
      let tel = this.operData.serviceTel ? this.operData.serviceTel :  this.operData.tel
      window.location.href="tel:" + tel;
    },
    getOperInfo(){
      getOperInfo({oprPkId: this.$common.get("oprPkId")}).then(data => {
        if (data.status === this.$config.ajaxStatus) {
          this.operData = data.data[0];
        }
      })
    },
    goProblem(){
      this.$router.push({
        name: "common-problem",
      });
    }
  },
  mounted() {
    this.getOperInfo();
  }
}
</script>